import { FormInstance, message } from "antd";
import { IDocumentList } from "store/process/process-model";
import { checkIfIsRequiredDocument } from "utils/form/validations";
import { checkDocumentId, checkDocumentIfIsNumber, searchProcessByDescriptionSelected } from "utils/functions";

type IOnConfirmDrawerNewProcess = {
  form: FormInstance<any>;
  eventInboundActive: boolean;
  eventOutboundActive: boolean;
  messageDescription: string;
  messageEvent: string;
  visibleDocuments: boolean;
  messageDocument: string;
  messageRequired: string;
  messageEqualDocuments: string;
  messageRequiredInbound: string;
  messageRequiredOutbound: string;
  allowImageCapture: boolean;
  processSaveNewProcessAsync: (...args) => void;
};

type IOnConfirmDrawerUpdateProcess = {
  formEdit: FormInstance<any>;
  documentsList: Array<IDocumentList>;
  processIdSelected?: number;
  eventInboundActive: boolean;
  eventOutboundActive: boolean;
  messageDescription: string;
  visibleDocuments: boolean;
  messageEvent: string;
  messageDocument: string;
  messageEqualDocuments: string;
  messageRequired: string;
  messageRequiredInbound: string;
  messageRequiredOutbound: string;
  allowImageCapture: boolean;
  processUpdateProcessAsync: (...args) => void;
};

const checkDocumentsTypes = (documentOutbound: boolean, documentInbound: boolean) => {
  let documentsTypes = [];
  documentsTypes = [];
  documentInbound === true && documentsTypes.push(1);
  documentOutbound === true && documentsTypes.push(2);
  return documentsTypes;
};

export const checkEvents = (eventInboundActive, eventOutboundActive) => {
  const events = [];
  const eventInboudId = 1;
  const eventOutboundId = 2;
  eventInboundActive && events.push(eventInboudId);
  eventOutboundActive && events.push(eventOutboundId);
  return events;
};

export const checkDocumentEvents = (documents) => {
  return documents.find((o) => o.documentOutbound === false && o.documentInbound === false);
};

export const messageError = (content) => {
  const messageKey = "messageProcess";
  return message.error({
    content: content,
    duration: 3,
    key: messageKey,
    onClick: () => message.destroy(messageKey),
  });
};

export const onConfirmDrawerNewProcess = async ({
  form,
  processSaveNewProcessAsync,
  eventInboundActive,
  eventOutboundActive,
  allowImageCapture,
  messageDescription,
  messageEvent,
  visibleDocuments,
  messageDocument,
  messageRequired,
  messageEqualDocuments,
  messageRequiredInbound,
  messageRequiredOutbound,
}: IOnConfirmDrawerNewProcess) => {
  try {
    await form.validateFields();
    const processDescription = form.getFieldValue("description");
    const documents = form.getFieldValue("documents");

    let document = [];
    document = [];

    if (visibleDocuments) {
      const checkDocument = documents.find((o) => o.id === undefined);
      if (checkDocument) {
        return messageError(messageDocument);
      }

      const checkRequired = documents.find((o) => o.required === undefined);
      if (checkRequired) {
        return messageError(messageRequired);
      }

      const checkIfDocumentsEventsAreChecked = checkDocumentEvents(documents);
      if (checkIfDocumentsEventsAreChecked) {
        return messageError(messageEvent);
      }

      const documentsIds = documents.map(function (item) {
        return item.id;
      });

      const duplicatatedDocument = documentsIds.some(function (item, idx) {
        return documentsIds.indexOf(item) !== idx;
      });
      if (duplicatatedDocument) {
        return messageError(messageEqualDocuments);
      }

      const checkRequiredDocuments = checkIfIsRequiredDocument(documents);
      if (checkRequiredDocuments.isRequiredInboundDocument) {
        return messageError(messageRequiredInbound);
      }

      if (checkRequiredDocuments.isRequiredOutboundDocument) {
        return messageError(messageRequiredOutbound);
      }

      document = documents.map((x) => {
        return {
          id: x.id,
          documentEventType: checkDocumentsTypes(x.documentOutbound, x.documentInbound),
          required: x.required,
        };
      });
    }

    const events = checkEvents(eventInboundActive, eventOutboundActive);

    const bodyRequest = {
      description: processDescription,
      documents: document.length > 0 ? document : [],
      events,
      allowImageCapture,
    };
    processSaveNewProcessAsync(bodyRequest);
  } catch (e) {
    console.error(new Error("Process form validation error"));
    messageError(messageDescription);
  }
  return true;
};

export const onConfirmDrawerUpdateProcess = async ({
  formEdit,
  documentsList,
  processIdSelected,
  eventInboundActive,
  eventOutboundActive,
  allowImageCapture,
  processUpdateProcessAsync,
  messageDescription,
  visibleDocuments,
  messageEvent,
  messageDocument,
  messageEqualDocuments,
  messageRequired,
  messageRequiredInbound,
  messageRequiredOutbound,
}: IOnConfirmDrawerUpdateProcess) => {
  try {
    await formEdit.validateFields();
    const processDescription = formEdit.getFieldValue("description");
    const documents = formEdit.getFieldValue("documents");
    let document = [];
    document = [];

    if (visibleDocuments) {
      const checkRequired = documents.find((o) => o.required === undefined);
      if (checkRequired) {
        return messageError(messageRequired);
      }

      const checkDocument = documents.find((o) => o.id === undefined);
      if (checkDocument) {
        return messageError(messageDocument);
      }

      const checkIfDocumentsEventsAreChecked = checkDocumentEvents(documents);
      if (checkIfDocumentsEventsAreChecked) {
        return messageError(messageEvent);
      }

      let ids = [];
      ids = [];
      checkDocumentIfIsNumber(ids, documents, documentsList);

      const duplicatatedDocument = ids.some(function (item, idx) {
        return ids.indexOf(item) !== idx;
      });
      if (duplicatatedDocument) {
        return messageError(messageEqualDocuments);
      }

      const checkRequiredDocuments = checkIfIsRequiredDocument(documents);
      if (checkRequiredDocuments.isRequiredInboundDocument) {
        return messageError(messageRequiredInbound);
      }

      if (checkRequiredDocuments.isRequiredOutboundDocument) {
        return messageError(messageRequiredOutbound);
      }

      document = documents.map((x) => {
        const documentId = searchProcessByDescriptionSelected(x.id, documentsList);
        return {
          id: checkDocumentId(documentId, x.id),
          documentEventType: checkDocumentsTypes(x.documentOutbound, x.documentInbound),
          required: x.required,
        };
      });
    }

    const events = checkEvents(eventInboundActive, eventOutboundActive);

    const bodyRequest = {
      id: processIdSelected,
      description: processDescription,
      documents: document.length > 0 ? document : [],
      allowImageCapture,
      events,
    };
    processUpdateProcessAsync(bodyRequest);
  } catch (e) {
    console.error(new Error("Process form validation error"));
    messageError(messageDescription);
  }
  return true;
};
